"use strict";

export var Objects = {
  SysAppObjects: "Sys_AppObjects",
  SysFormFilterFields: "Sys_FormFilterFields",
  SysAppObjectOperations: "Sys_AppObjectOperations",
  SysSubsystems: "Sys_Subsystems",
  SysForms: "Sys_Forms",
  SysFormFields: "Sys_FormFields",
  SysFormGroups: "Sys_FormGroups",
  SysUsers: "Sys_Users",
  SysRoles: "Sys_Roles",
  SysRoleOperationAccess: "Sys_RoleOperationAccess",
  SysRoleFieldsRestriction: "Sys_RoleFieldsRestriction",
  SysRoleSubsystemAccess: "Sys_RoleSubsystemAccess",
  SysPositions: "Sys_Positions",
  SysPositionRoles: "Sys_PositionRoles",
  SysPositionAccess: "Sys_PositionAccess",
  SysUserPositions: "Sys_UserPositions",
  SysUserPositionAdditionAccess: "Sys_UserPositionAdditionAccess",
  SysFormButtons: "Sys_FormButtons",
  SysFormFieldEvents: "Sys_FormFieldEvents",
  SysSubForms: "Sys_SubForms",
  SysAppObjectFilters: "Sys_AppObjectFilters",
  SysFormButtonEvents: "Sys_FormButtonEvents",
  SysFormFilterFieldEvents: "Sys_FormFilterFieldEvents",
  SysFormDecorationElements: "Sys_FormDecorationElements"
};
export var Fields = {
  _id: "_id",
  ID: "ID",
  UserID: "UserID",
  PersonID: "PersonID",
  ObjectID: "ObjectID",
  ObjectID_Name: "ObjectID.Name",
  ObjectID_KeyObjectFieldID_Name: "ObjectID.KeyObjectFieldID.Name",
  ObjectID_KeyObjectFieldID_FieldType: "ObjectID.KeyObjectFieldID.FieldType",
  Order: "Order",
  Name: "Name",
  ParentSubsystemID: "ParentSubsystemID",
  FormID: "FormID",
  FormID_Type: "FormID.Type",
  FormID_Name: "FormID.Name",
  FormID_Title: "FormID.Title",
  FormID_ViewMode: "FormID.ViewMode",
  FormID_ObjectID: "FormID.ObjectID",
  FormID_ObjectID_Name: "FormID.ObjectID.Name",
  FormID_ObjectID_KeyObjectFieldID_Name: "FormID.ObjectID.KeyObjectFieldID.Name",
  IsGroup: "IsGroup",
  ObjectFieldID: "ObjectFieldID",
  ObjectFieldID_Name: "ObjectFieldID.Name",
  ObjectFieldID_IsKey: "ObjectFieldID.IsKey",
  ObjectFieldID_FieldType: "ObjectFieldID.FieldType",
  ObjectFieldID_NumberScale: "ObjectFieldID.NumberScale",
  ObjectFieldID_IsTimeAllowed: "ObjectFieldID.IsTimeAllowed",
  ObjectFieldID_NumberPrecision: "ObjectFieldID.NumberPrecision",
  ObjectFieldID_IsDisplayField: "ObjectFieldID.IsDisplayField",
  ObjectFieldID_LinkedObjectID: "ObjectFieldID.LinkedObjectID",
  ObjectFieldID_LinkedObjectID_Name: "ObjectFieldID.LinkedObjectID.Name",
  ObjectFieldID_DisplayObjectFieldID: "ObjectFieldID.LinkedObjectID.DisplayObjectFieldID",
  ObjectFieldID_DisplayObjectFieldID_Name: "ObjectFieldID.LinkedObjectID.DisplayObjectFieldID.Name",
  ObjectFieldID_DisplayObjectFieldID_FieldType: "ObjectFieldID.LinkedObjectID.DisplayObjectFieldID.FieldType",
  ObjectFieldID_KeyObjectFieldID: "ObjectFieldID.LinkedObjectID.KeyObjectFieldID",
  ObjectFieldID_KeyObjectFieldID_Name: "ObjectFieldID.LinkedObjectID.KeyObjectFieldID.Name",
  ObjectFieldID_KeyObjectFieldID_FieldType: "ObjectFieldID.LinkedObjectID.KeyObjectFieldID.FieldType",
  DisplayField: "DisplayField",
  GroupID: "GroupID",
  KeyObjectFieldID: "KeyObjectFieldID",
  KeyObjectFieldID_Name: "KeyObjectFieldID.Name",
  DisplayObjectFieldID: "DisplayObjectFieldID",
  DisplayObjectFieldID_Name: "DisplayObjectFieldID.Name",
  GroupID_ParentGroupID: "GroupID.ParentGroupID",
  GroupID_Title: "GroupID.Title",
  Title: "Title",
  IsShowTitle: "IsShowTitle",
  IsReadOnly: "IsReadOnly",
  IsMultiselect: "IsMultiselect",
  IsVisible: "IsVisible",
  IsUseTime: "IsUseTime",
  SortByDefault: "SortByDefault",
  AppObjectID: "AppObjectID",
  AppObjectID_Name: "AppObjectID.Name",
  IsKey: "IsKey",
  FieldType: "FieldType",
  LineCount: "LineCount",
  KeyFilterField: "KeyFilterField",
  KeyDictionaryField: "KeyDictionaryField",
  ButtonType: "ButtonType",
  Position: "Position",
  IconType: "IconType",
  ActionFormID: "ActionFormID",
  Type: "Type",
  EditMode: "EditMode",
  ParentGroupID: "ParentGroupID",
  Orientation: "Orientation",
  GroupType: "GroupType",
  IsCollapsed: "IsCollapsed",
  ObjectFieldID_IsRequired: "ObjectFieldID.IsRequired",
  ViewMode: "ViewMode",
  IsDisplayField: "IsDisplayField",
  DisplayType: "DisplayType",
  Icon: "Icon",
  Style: "Style",
  DetailFormID: "DetailFormID",
  DetailFormID_Type: "DetailFormID.Type",
  DetailFormID_Name: "DetailFormID.Name",
  MasterObjectFieldID: "MasterObjectFieldID",
  DetailObjectFieldID: "DetailObjectFieldID",
  MasterObjectFieldID_Name: "MasterObjectFieldID.Name",
  DetailObjectFieldID_Name: "DetailObjectFieldID.Name",
  EventTypeID: "EventTypeID",
  FormFieldID: "FormFieldID",
  FormFilterFieldID: "FormFilterFieldID",
  FunctionName: "FunctionName",
  FormButtonID: "FormButtonID",
  CustomParameters: "CustomParameters",
  CustomOperation: "CustomOperation",
  LinkedObjectID: "LinkedObjectID",
  LinkedObjectID_Name: "LinkedObjectID.Name",
  LinkedObjectID_DisplayObjectFieldID: "LinkedObjectID.DisplayObjectFieldID",
  LinkedObjectID_DisplayObjectFieldID_Name: "LinkedObjectID.DisplayObjectFieldID.Name",
  LinkedObjectID_DisplayObjectFieldID_FieldType: "LinkedObjectID.DisplayObjectFieldID.FieldType",
  LinkedObjectID_KeyObjectFieldID: "LinkedObjectID.KeyObjectFieldID",
  LinkedObjectID_KeyObjectFieldID_Name: "LinkedObjectID.KeyObjectFieldID.Name",
  LinkedObjectID_KeyObjectFieldID_FieldType: "LinkedObjectID.KeyObjectFieldID.FieldType",
  RegionalLocale: "RegionalLocale",
  AppLang: "AppLang",
  ParentFieldID: "ParentFieldID",
  ParentFieldID_Name: "ParentFieldID.Name",
  ParentFieldID_Type: "ParentFieldID.Type",
  ParentFieldID_LinkedObjectID: "ParentFieldID.LinkedObjectID",
  TitlePosition: "TitlePosition",
  TitleType: "TitleType",
  ParameterFieldName: "ParameterFieldName",
  ReportURL: "ReportURL",
  MainGroupID: "MainGroupID",
  NestedFieldID: "NestedFieldID",
  NestedFieldID_Name: "NestedFieldID.Name",
  RelationType: "RelationType",
  IsShowInMainForm: "IsShowInMainForm",
  ActionFormID_Type: "ActionFormID.Type",
  IsRequired: "IsRequired",
  IsShowRoot: "IsShowRoot",
  RootName: "RootName",
  DisplayCustomParam: "DisplayCustomParam",
  TotalFunction: "TotalFunction",
  DateFrom: "DateFrom",
  DateTo: "DateTo",
  IsShowTotals: "IsShowTotals",
  Width: "Width"
};
export var System = {
  _Changed: '_Changed',
  THEME: {
    LIGHT: 'LIGHT',
    BLUE: 'BLUE'
  },
  FILTER_OPERATIONS: {
    equal: '=',
    notequal: '<>',
    less: '<',
    greater: '>',
    lessorequal: '<=',
    greaterorequal: '>=',
    contains: 'contains',
    between: 'between',
    isanyof: 'isanyof',
    isnotanyof: 'isnotanyof',
    isblank: 'isblank',
    isnotblank: 'isnotblank'
  },
  DIRECTION: {
    LTR: 'ltr',
    RTL: 'rtl',
    LEFT: 'left',
    RIGHT: 'right'
  },
  VIEW_MODE: {
    FULL_SCREEN: 1,
    MODAL: 2,
    IN_NEW_WINDOW: 3
  },
  EDIT_MODE: {
    FORM: 0,
    INLINE: 1,
    CELL: 2
  },
  FORM_EDIT_CREATE_MODE: {
    ADD: 'add',
    EDIT: 'edit',
    MULTI_EDIT: 'multi_edit'
  },
  FORM_TYPE: {
    //custom types
    MAIN_FORM: -1,
    FILTER_MODAL: -2,
    SETTINGS_MODAL: -3,
    //server types
    LIST: 1,
    EDIT: 2,
    TREE: 3,
    REPORT: 4,
    MULTI_EDIT: 5
  },
  FORM_ORIENTATION: {
    HORIZONTAL: 1,
    VERTICAL: 2
  },
  USER_EVENT_TYPE: {
    ON_VALUE_CHANGED: 1
  },
  USER_SETTINGS: {
    APP_SETTINGS: 'app_settings',
    REGIONAL_SETTINGS: 'RegionalSettings',
    APPLICATION_LANG: 'APPLICATION_LANG'
  },
  RELATION_TYPE: {
    MASTER: 1,
    DETAIL: 2
  },
  BUTTON_TYPE: {
    CUSTOM: 0,
    ADD: 1,
    EDIT: 2,
    DELETE: 3,
    REFRESH: 4,
    FILTER: 5,
    MULTI_EDIT: 5,
    GOTO: 6,
    REPORT: 7,
    COPY: 8
  },
  BUTTON_POSITION: {
    NONE: 0,
    TOOLBAR: 1,
    CONTEXT_MENU: 2,
    ALL: 3,
    IN_GROUP: 4
  },
  FILE_NOT_FOUND: 'FILE_NOT_FOUND',
  FUNCTION_NOT_FOUND: 'FUNCTION_NOT_FOUND',
  uid: 'uid',
  login: 'login',
  page404: 'page404',
  personID: 'personID',
  current_user: 'current_user',
  ReturnUrl: 'return_url',
  FIELD_EDITOR_TYPE: {
    BOOL_CB: 'bool',
    BOOL_SB: 'boolTable',
    DATE: 'date',
    DATETIME: 'datetime',
    DATE_TWIN: 'dateTwin',
    MULTI_SELECT: 'multiSelect',
    SELECT: 'select',
    NUMBER: 'number',
    NUMBER_TWIN: 'numberTwin',
    TEXT: 'string',
    IS_BLANK: 'isblank',
    IS_NOT_BLANK: 'isnotblank',
    ANY_OF: 'anyof'
  },
  GROUP_TYPE: {
    PANEL: 0,
    TAB_PANEL: 1,
    TAB: 2,
    ACCORDION: 3,
    TABLE_HEADER: 4,
    BUTTONS: 5 //Custom groups

  },
  FIELD_TYPE: {
    TEXT: 0,
    NUMBER: 1,
    DATE: 2,
    BOOL: 3,
    BUTTON: 'button',
    DECORATION: 'decoration'
  },
  DECORATION_FIELD_TYPE: {
    TEXT: 0,
    IMAGE: 1
  },
  TITLE_POSITION: {
    LEFT: 1,
    RIGHT: 2,
    TOP: 0
  },
  TITLE_TYPE: {
    ICON: 1,
    TITLE: 2,
    ICON_AND_TITLE: 3
  },
  FILTER_SENDERS: {
    FORM: 'formFilters',
    LAYOUT: 'layoutFilters',
    TABLE: 'tableFilters',
    FORM_EDIT: 'formEdit'
  },
  USER_SCRIPTS_INITIATOR: {
    TABLE: 'table',
    TREE: 'tree',
    FORM_EDIT: 'formEdit'
  },
  SNACKBAR_TYPES: {
    Error: 'error',
    Success: 'success',
    Info: 'info',
    Warning: 'warning'
  },
  DEF_FE_BUTTON_EVENTS: {
    SUBMIT: 'submit',
    APPLY: 'apply',
    CANCEL: 'cancel'
  },
  DX_CONTROLS: {
    dxTextArea: 'dxTextArea',
    dxTextBox: 'dxTextBox',
    dxNumberBox: 'dxNumberBox',
    dxDateBox: 'dxDateBox',
    dxCheckBox: 'dxCheckBox',
    dxButton: 'dxButton',
    dxSelectBox: 'dxSelectBox',
    dxTagBox: 'dxTagBox'
  },
  FORM_STATE_PROPS: {
    FIELDS: 'fields'
  },
  TOOLBAR_BTN_CLASSES: {
    EDIT: 'table-form-edit-button',
    MULTI_EDIT: 'table-form-multi-edit-button',
    DEL: 'table-form-delete-button',
    SELECT: 'table-form-select-all',
    DESELECT: 'table-form-deselect-all',
    GOTO: 'table-form-goto-button',
    REPORTS: 'table-form-reports-button',
    SEARCH: 'table-form-search-button',
    ADD: 'table-form-add-button',
    REFRESH: 'table-form-refresh-button',
    EXPORT: 'table-form-export-button'
  },
  API_OPERATION: {
    CREATE: 'Ins',
    READ: 'List',
    UPDATE: 'Mod',
    DELETE: 'Del'
  },
  SYSTEM_PREFIX: '_system_',
  TEMPLATE_TYPE: {
    BUTTON: 'button',
    TITLE: 'title'
  },
  ORIENTATION: {
    NUM: {
      COLUMN: 1,
      ROW: 2
    },
    STR: {
      COLUMN: 'col',
      ROW: 'row'
    }
  },
  LAYOUT_TYPE: {
    FILTER: 'fitler',
    SUBFORM: 'subform',
    DECORATION: 'decoration'
  },
  TOTAL_FUNC_KINDS: {
    NONE: 0,
    SUM: 1,
    COUNT: 2,
    AVG: 3,
    MIN: 4,
    MAX: 5
  }
};